import logo from "../../../assets/images/logo.png";
import { Input } from "../../../components/textfield";
import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

interface ParamsType {
  id: string;
}
const ViewComplication = () => {
  const { id } = useParams<ParamsType>();
  const [name, setName] = useState<string>("");
  const [channel, setChanNel] = useState<string>("");
  const [comPlicationNo, setComPlicationNo] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const [comPlication, setComPlication] = useState<string>("");
  const [status, setStatus] = useState<string>("");

  const getAPIs = () => {
    setName("นางสาว รังสิมา แซ่หว่าง");
    setChanNel("EK-CNT60100015");
    setComPlicationNo("CO-0000589");
    setDate("20-03-2021");
    setComPlication("มีอาการผื่นแดงขึ้นบริเวณลำคอ");
    setStatus("Pending");
  };

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar btnBack={true} title="น.ส.รังสิมา แซ่หว่าง (EK-CNT60100015)" />
      <div style={{ padding: "20px 40px", margin: "10px 40px" }}>
        <h5>รายงานเคส Complication ของแผนก AESTHETIC</h5>
        <div
          className="mt-20 card-view"
          style={{
            padding: "20px 80px",
            flexDirection: "column",
            fontSize: "16px",
          }}
        >
          <div className="justify-center">
            <div style={{ textAlign: "center" }}>
              <img src={logo} />
              <div>รายงานเคส Complication ของแผนก AESTHETIC</div>
            </div>
          </div>

          <div className="row space-between mt-20">
            <div className="col-4">
              ชื่อ (Name): <b>{name}</b>
            </div>
            <div className="col-3">
              CN: <b>{channel}</b>
            </div>
            <div className="col-3">
              Complication NO: <b>{comPlicationNo}</b>
            </div>
            <div className="col-2" style={{ textAlign: "end" }}>
              วันที่: <b>{date}</b>
            </div>
          </div>

          <div className="row space-between mt-20">
            <div className="col-5">
              Complication: <b>{comPlication}</b>
            </div>

            <div className="col-5" style={{ textAlign: "end" }}>
              Status: <b>{status}</b>
            </div>
          </div>

          <div className="view-table">
            <table width="100%">
              <tr>
                <td className="thead" width="80%" align="center">
                  Procedure
                </td>
                <td className="thead" width="20%" align="center">
                  ประเมินค่าใช้จ่าย
                </td>
              </tr>
              <tr>
                <td className="tbody">
                  <div className="pd-10">
                    <div className="row space-between">
                      <div className="col-6">Before</div>
                      <div className="col-6" style={{ textAlign: "end" }}>
                        Date : 18-03-2021
                      </div>
                      <div className="row">
                        <div className="col-8">
                          <Input other />
                          <Input other />
                          <Input other />
                          <Input other />
                          <Input other />
                          <Input other />
                        </div>
                        <img
                          className="col-4"
                          height="200"
                          src="https://www.sukumvithospital.com/uploadimages/skhimg1941.jpg"
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="tbody pd-10" rowSpan={2}>
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                </td>
              </tr>
              <tr>
                <td className="tbody">
                  <div className="pd-10">
                    <div className="row space-between">
                      <div className="col-6">After</div>
                      <div className="col-6" style={{ textAlign: "end" }}>
                        Date : 20-03-2021
                      </div>
                      <div className="row">
                        <div className="col-8">
                          <Input other />
                          <Input other />
                          <Input other />
                          <Input other />
                          <Input other />
                          <Input other />
                        </div>
                        <img
                          className="col-4"
                          height="200"
                          src="https://www.sukumvithospital.com/uploadimages/skhimg1941.jpg"
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <table className="sub-table" width="100%">
              <tr>
                <td className="thead" width="33.33%" align="center">
                  ความเห็นแพทย์ผ่าตัด / แผนการรักษา
                </td>
                <td className="thead" width="33.33%" align="center">
                  ความเห็นผู้อำนวยการแพทย์
                </td>
                <td className="thead" width="33.33%" align="center">
                  ความเห็นกรรมการผู้จัดการ
                </td>
              </tr>
              <tr>
                <td className="tbody pd-10">
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                </td>
                <td className="tbody pd-10">
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                </td>
                <td className="tbody pd-10">
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                  <Input className="col-12" other />
                </td>
              </tr>
            </table>

            <table className="sub-table" width="100%">
              <tr>
                <td className="signature" width="50%" align="center">
                  <div style={{ padding: "40px 0px" }}>
                    <div>ผู้จัดทำ Dr.Harirak Artamnuayvipas</div>
                    <div className="justify-center mt-20">
                      ( <Input className="col-6 " other />)
                    </div>
                    <div>Manager</div>
                  </div>
                </td>

                <td className="signature" width="50%" align="center">
                  <div style={{ padding: "40px 0px" }}>
                    <Input className="col-6 mt-20" other />
                    <div>Sale</div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div className="justify-center mt-20">
          <MainButton
            title="ย้อนกลับ"
            to="/opd/list/EK-CNT60100015/view/view-complication"
            background="#E76464"
          />
          <div style={{ width: "20px" }}></div>

          <MainButton
            title="Print"
            to="/opd/list/EK-CNT60100015/view/view-complication"
            background="#4285F4"
          />
        </div>
      </div>
    </div>
  );
};
export default ViewComplication;
